import type { Optional } from '@festina-life/core'
import type { TreeNodeData } from '@festina-life/ui/listsAndTables'
import { useMemo } from 'react'

import { resolveCurrentActiveItemFromPath } from './helpers'
import type { ActiveConfigurationItem, ConfigurationTreeLeaf } from './types'

export const useNodePathToActiveConfigurationItem = (
  tree: TreeNodeData<ConfigurationTreeLeaf>[],
  currentNodePath: Optional<string>,
): Optional<ActiveConfigurationItem> => {
  const treeNodesByPath = useMemo(() => {
    const treePaths = new Map<string, TreeNodeData<ConfigurationTreeLeaf>>()

    const visit = (nodes: TreeNodeData<ConfigurationTreeLeaf>[]) => {
      nodes.forEach((node) => {
        treePaths.set(node.path.join('.'), node)
        visit(node.nodes)
      })
    }

    visit(tree)

    return treePaths
  }, [tree])

  return useMemo(
    () =>
      currentNodePath
        ? resolveCurrentActiveItemFromPath({
            activePath: currentNodePath,
            nodesByPath: treeNodesByPath,
          })
        : undefined,
    [currentNodePath, treeNodesByPath],
  )
}
